import { djb2Hash } from './djb2-hash.util';

const HEX_RADIX = 16;
const HEX_WIDTH = 8;
const EMPTY_HASH = '0'.repeat(HEX_WIDTH);

/**
 * Hash content to an 8-character hex string (32 bits).
 *
 * The empty string, `null` and `undefined` all hash to `'00000000'` rather than to the djb2 seed, so
 * "no content" is one stable value a caller can compare against.
 *
 * Ported from Clarity `apps/web/src/shared/utils/hashUtils.ts`.
 */
export function hashContent(content: string): string {
	if (!content) {
		return EMPTY_HASH;
	}

	return djb2Hash(content).toString(HEX_RADIX).padStart(HEX_WIDTH, '0');
}
